import cx from "classnames";
import { useSortBy, useTable } from "react-table";
import arrowIcon from "../_assets/vectors/arrow.svg";

function Table({ columns, data, theadClassName }) {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,

        // initialState: { pageIndex: 0, hiddenColumns: ['communityRole'] }
      },
      useSortBy
    );

  const PageRows = rows;

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (
      column.isSortedDesc ? (
        // down
        <img src={arrowIcon} className="ml-1" width="12" alt="" />
      ) : (
        // up
        <img
          src={arrowIcon}
          className="transform rotate-180 ml-1"
          width="12"
          alt=""
        />
      )
    ) : (
      ""
    );
  };

  return (
    <>
      <table {...getTableProps()} className="w-full">
        <thead
          className={cx(`font-normal rounded select-none ${theadClassName}`)}>
          {headerGroups.map((headerGroup, index) => (
            <tr
              key={index}
              align="center"
              {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                // Add the sorting props to control sorting.
                // we can add them into the header props
                <th
                  key={index}
                  align="center"
                  {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <span className="flex justify-center">
                    {column.render("Header")}

                    {generateSortingIndicator(column)}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {PageRows.map((row, index) => {
            prepareRow(row);
            return (
              <tr key={index} {...row.getRowProps()}>
                {row.cells.map((cell, indx) => {
                  return (
                    <td key={indx} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {data.length === 0 ? (
        <div className="w-full text-center mt-4">
          <span className="text-gray-600 text-xs text-center">
            No rows found
          </span>
        </div>
      ) : null}
      <br />
    </>
  );
}

export default Table;
